import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";
import SectionHeading from "@/components/feature/SectionHeading";

export default function NewsList({ items }: { items: NewsItem[] }) {
  return (
    <section aria-labelledby="latest-news">
      <SectionHeading
        icon="ri-newspaper-line"
        title="最新影视资讯"
        subtitle="按时间顺序更新的影视动态与追更提醒"
      />
      {items.length === 0 ? (
        <p className="rounded-lg border border-dashed border-background-300 bg-background-100 px-4 py-8 text-center text-sm text-foreground-500">
          暂无最新资讯
        </p>
      ) : (
        <ul className="flex flex-col divide-y divide-background-200">
          {items.map((item) => (
            <li key={item.id}>
              <Link
                to={`/detail/${item.movieId}`}
                className="group flex gap-3.5 py-3.5 transition-colors"
              >
                <div className="h-[68px] w-[100px] shrink-0 overflow-hidden rounded-md bg-background-200">
                  <img
                    src={item.cover}
                    alt={`${item.title} 资讯封面`}
                    title={`${item.title} - 黑桃视频影视资讯`}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex min-w-0 flex-1 flex-col justify-center">
                  <h3 className="truncate text-sm font-500 text-foreground-900 transition-colors group-hover:text-primary-500">
                    {item.title}
                  </h3>
                  <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                    {item.summary}
                  </p>
                  <div className="mt-1.5 flex items-center gap-2 text-[11px] text-foreground-500">
                    <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-900">{item.tag}</span>
                    <span>{item.date}</span>
                  </div>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}